import React from 'react'
import useSWR from 'swr'
import { ApiKeys } from '../../apiKeys'
import { fetchCurrentUser } from '@library/api-user'
import { Join, Space } from '@gousto-internal/citrus-react'
import { PaymentCardSection } from './PaymentCardSection/PaymentCardSection'

export const PaymentInfo = () => {
  const { data } = useSWR(ApiKeys.UserCurrent, fetchCurrentUser)
  const userId = data?.user.id
  return (
    <>
      <Space size={6} direction="vertical" />
      <Join with={<Space size={6} />}>
        <PaymentCardSection userId={userId} />
      </Join>
      <Space size={6} direction="vertical" />
    </>
  )
}
